import { api } from '@api/api';
import { Middleware } from '@reduxjs/toolkit';
import { RootState } from '@store';

export const translationMiddleware: Middleware<{}, RootState> = (store) => (next) => (action) => {
  if (api.endpoints.getTranslations.matchFulfilled(action)) {
    window.translations = action?.payload?.data?.translations;
  }
  return next(action);
};
